"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Subscription = void 0;
var _react = _interopRequireDefault(require("react"));
var _Grid = _interopRequireDefault(require("../common/Grid"));
var _SuccessIcon = _interopRequireDefault(require("../../../SuccessIcon"));
var _Throbber = _interopRequireDefault(require("../../../Throbber"));
var _constants = require("./constants");
var _styles = require("./styles");
var Subscription = exports.Subscription = function Subscription(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? '#fff' : _ref$color,
    onClick = _ref.onClick,
    loading = _ref.loading,
    success = _ref.success;
  var isIdle = success === null;
  return /*#__PURE__*/_react["default"].createElement(_Grid["default"], {
    style: _styles.styles.table
  }, isIdle ? /*#__PURE__*/_react["default"].createElement(_styles.Button, {
    color: color,
    onClick: onClick,
    disabled: loading
  }, loading && /*#__PURE__*/_react["default"].createElement(_Throbber["default"], {
    size: 16,
    color: "#007AFF"
  }), /*#__PURE__*/_react["default"].createElement(_styles.ButtonText, {
    loading: loading
  }, _constants.textButton.idle)) : /*#__PURE__*/_react["default"].createElement(_styles.StatusBlock, {
    success: success
  }, /*#__PURE__*/_react["default"].createElement(_SuccessIcon["default"], {
    size: 48,
    success: success
  }), /*#__PURE__*/_react["default"].createElement(_styles.StatusText, null, success ? _constants.textStatus.success : _constants.textStatus.failed), /*#__PURE__*/_react["default"].createElement(_styles.Button, {
    color: color,
    onClick: onClick
  }, /*#__PURE__*/_react["default"].createElement(_styles.ButtonText, null, success ? _constants.textButton.success : _constants.textButton.failed))));
};